export default __webpack_public_path__ + "static/media/pantry1-afterD-768w.66354422.webp";